import {Base} from './Base';

export class MissingItemReport implements Base {
  id: string; // going to be generated by the backend
  userId: string;
  itemId: string;
  name: string;
  category: MissingItemCategory;
  get categoryDisplay(): string { return MissingItemCategoryDisplayValues[this.category]; }
  missingBarcode: string;
  itemName: string;
  brandName: string;
  comments: string;
  teamComments: string; // potential message from idoplanty team to the user
  receiveEmail: boolean;
  status: MissingItemReportStatus;
  result: MissingItemReportResult;
  createdAt: Date; // going to be generated by the backend
  lastChangedAt: Date; // going to be generated by the backend
  history: MissingItemReportHistoryEntry[]; // to store the last states of the report
  wasSeen: boolean; // flag to hide alert if already seen by user
  followupUserComments: string; // if user wants to follow up after update

  get categoryUnknown(): boolean { return this.category === MissingItemCategory.all; }
  get categoryFood(): boolean { return this.category === MissingItemCategory.food; }
  get categoryRecipe(): boolean { return this.category === MissingItemCategory.recipe; }
  get categoryProduct(): boolean { return this.category === MissingItemCategory.foodProduct; }
  get itemAdded(): boolean { return this.result === MissingItemReportResult.itemAdded; }
  get declined(): boolean { return this.result === MissingItemReportResult.declined; }

  constructor(i?: IMissingItemReport) {
    if (i) {
      Object.assign(this, i);
      if (i.createdAt) { this.createdAt = new Date(i.createdAt); }
      if (i.lastChangedAt) { this.lastChangedAt = new Date(i.lastChangedAt); }
      if (i.history) {
        this.history.map(h => h.lastChangedAt = new Date(h.lastChangedAt));
      }
    }
  }

  toInterface(): IMissingItemReport {
    return {
      ...this,
    };
  }
}

export interface IMissingItemReport {
  id: string; // going to be generated by the backend
  userId: string;
  itemId: string;
  name: string;
  category: MissingItemCategory;
  missingBarcode: string;
  itemName: string;
  brandName: string;
  comments: string;
  teamComments: string; // potential message from idoplanty team to the user
  receiveEmail: boolean;
  status: MissingItemReportStatus;
  result: MissingItemReportResult;
  createdAt: Date; // going to be generated by the backend
  lastChangedAt: Date; // going to be generated by the backend
  history: MissingItemReportHistoryEntry[];
  wasSeen: boolean;
  followupUserComments: string;
}


export interface MissingItemReportHistoryEntry {
  comments: string;
  teamComments: string;
  lastChangedAt: Date;
  status: MissingItemReportStatus;
  result: MissingItemReportResult;
}

export enum MissingItemCategory {
  all, food, recipe, foodProduct
}

export const MissingItemCategoryDisplayValues: { [key: number]: string } = {
  [MissingItemCategory.all]: 'Unbekannt',
  [MissingItemCategory.food]: 'Lebensmittel',
  [MissingItemCategory.recipe]: 'Rezept',
  [MissingItemCategory.foodProduct]: 'Produkt'
};

export enum MissingItemReportStatus {
  created, inProcess, completed, reOpenedByUser
}

export enum MissingItemReportResult {
  undefined, itemAdded, declined
}
